export default __webpack_public_path__ + "assets/078dee71358403fdb16c129a6f45a1d0.jpeg";